import React from 'react'
import { Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

export const DataRetentionWarning: React.FC = () => (
  <Row className='px-2 py-3 zocks-bg-color-gray-100 gap-3 justify-content-start border border-1 rounded'>
    <div className='d-flex align-self-center gap-3 align-items-center zocks-text-gray-700'>
      <i className='bi bi-exclamation-triangle' />
      <span>
        Meetings without consent will be deleted in line with your{' '}
        <NavLink to='/workspace/setup/settings/data-retention' target='_blank' rel='noreferrer' className='zocks-text-primary text-decoration-underline'>
          data retention policy settings
        </NavLink>
        .
      </span>
    </div>
  </Row>
)
